import { stateSwitch } from '../stateSwitch';
import { sendStatistics, completeMeasurement } from '../spenttime/measurement';
import { spenttimeDebug as debug } from '../debug';
import { throttle } from 'throttle-debounce';
import { THROTTLE_DELAY } from '../../constants';
/**
 * Timer identifier of the countdown, that the user will soon fall asleep
 * (absent for some time and does not show activity)
 */
var timerIdUserFallsAsleep = null;
/**
 * Timer identifier of the countdown, that the user will leave soon
 * (absent for a long time and does not show activity)
 */
var timerIdUserLeaves = null;
/**
 * Starts the timer of user leaves
 * Аfter the time has expired, we believe that the user has left.
 */
var controlOfLeaving = function () {
    timerIdUserLeaves = window.setTimeout(function () {
        debug('[event] User leaves. Measurement will be completed');
        sendStatistics();
        completeMeasurement();
    }, stateSwitch.config.forcedDepartureTime);
};
/**
 * Starts the timer of user's sleep
 * Аfter the time has expired, we believe that the user has fallen asleep.
 */
var controlOfFallingAsleep = function () {
    timerIdUserFallsAsleep = window.setTimeout(function () {
        debug('[event] User fells asleep');
        stateSwitch.setState({ userIsSleeping: true });
        sendStatistics();
        controlOfLeaving();
    }, stateSwitch.config.fallAsleepTime);
};
/**
 * Clear timer "User falls asleep" and timer "User leaves"
 */
export var clearTimers = function () {
    if (timerIdUserFallsAsleep) {
        clearTimeout(timerIdUserFallsAsleep);
        timerIdUserFallsAsleep = null;
    }
    if (timerIdUserLeaves) {
        clearTimeout(timerIdUserLeaves);
        timerIdUserLeaves = null;
    }
};
/**
 * Restart timers
 */
export var restartTimers = function () {
    clearTimers();
    controlOfFallingAsleep();
};
/**
 * Throttle of activity handler
 */
var activity = throttle(THROTTLE_DELAY, function () {
    debug('[event] User is doing something (activity)');
    stateSwitch.setState({ userIsSleeping: false, pageIsVisible: true });
    restartTimers();
});
/**
 * unload event handler
 * Can set the state 'userLeaves'
 */
var unloadHandler = function () {
    sendStatistics();
    completeMeasurement();
};
/**
 * beforeunload event handler
 * Can set the state 'userLeaves'
 */
var beforeunloadHandler = function () {
    sendStatistics();
    completeMeasurement();
};
/**
 * activity ('mouseup', 'keyup', 'scroll', 'mousemove', 'touchend', 'touchmove', 'focus') event handler
 * Can set the state 'userIsSleeping'
 */
var activityHandler = function () {
    activity();
};
export var addUserActivityListeners = function () {
    restartTimers();
    window.addEventListener('unload', unloadHandler);
    window.addEventListener('beforeunload', beforeunloadHandler);
    window.addEventListener('focus', activityHandler);
    // Catching user activity
    window.addEventListener('mouseup', activityHandler);
    window.addEventListener('mousemove', activityHandler);
    window.addEventListener('keyup', activityHandler);
    window.addEventListener('scroll', activityHandler);
    window.addEventListener('touchend', activityHandler);
    window.addEventListener('touchmove', activityHandler);
    debug('[event] User activity event listeners have been added');
};
export var removeUserActivityListeners = function () {
    window.removeEventListener('unload', unloadHandler);
    window.removeEventListener('beforeunload', beforeunloadHandler);
    window.removeEventListener('focus', activityHandler);
    window.removeEventListener('mouseup', activityHandler);
    window.removeEventListener('mousemove', activityHandler);
    window.removeEventListener('keyup', activityHandler);
    window.removeEventListener('scroll', activityHandler);
    window.removeEventListener('touchend', activityHandler);
    window.removeEventListener('touchmove', activityHandler);
    clearTimers();
    debug('[event] User activity event listeners have been removed');
};
